<div id="container" class="p-grid p-m-0 p-p-0 p-jc-center p-ai-center bg-gris">
  <div class="p-col-12 p-sm-6 p-md-5 p-lg-4 p-xl-6 p-offset-0 p-offset-md-1 p-px-4 p-px-md-3 p-py-5 p-py-md-6" style="max-width: 1200px; z-index: 999;">
    <p-card>
      <h1>Inicia sesión con tus datos</h1>
      <p class="p-py-3" style="font-size: .93rem">Debes ingresar a tu cuenta con el código enviado a tu correo al momento de registrarte, si eres nuevo y no posees el código deberás postular previamente a uno de los cursos.</p>
      <form [formGroup]="form">
        <div class="p-grid p-fluid p-pt-3">

          <div class="p-col-12 p-d-flex p-ai-center p-ml-2">
            <span class="p-mb-2 p-mr-2">Soy extranjero:</span>
            <p-inputSwitch [disabled]="form.disabled" (onChange)="changeExtranjero($event)"></p-inputSwitch>
          </div>

          <!-- RUT -->
          <div *ngIf="!extranjero" class="p-col-12 p-md-12 p-lg-12 p-xl-11 p-mb-3">
            <span class="p-float-label">
              <input type="text" id="inputtext" [maxLength]="10" (keypress)="regExpInput('^[0-9kK\-]',$event)" pInputText formControlName="run">
              <label for="inputtext">Run <small>(Ej: 12345678-9)</small></label>
            </span>
            <div *ngIf="form.get('run').invalid && (form.get('run').dirty || form.get('run').touched)">
              <span class="p-error" *ngIf="form.get('run').hasError('required')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su Run.</small>
              </span>
              <span class="p-error" *ngIf="form.get('run').hasError('minlength')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un Run válido.</small>
              </span>
              <span class="p-error" *ngIf="form.get('run').errors?.invalidRun">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El Run ingresado no es válido.</small>
              </span>
              <span class="p-error" *ngIf="form.get('run').hasError('maxlength')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
              </span>
            </div>
          </div>

          <!-- NUMERO PASAPORTE postulante, si se habilita a extranjeros -->
          <div *ngIf="extranjero" class="p-col-12 p-md-12 p-lg-12 p-xl-11 p-mb-3">
            <span class="p-float-label">
              <input type="text"  [maxLength]="50" (keypress)="regExpInput('^[a-zA-Z0-9]',$event)" pInputText formControlName="nroPasaporte">
              <label for="inputtext">Nro. Identificación <small>(DNI/Pasaporte/Otro)</small></label>
            </span>
            <div *ngIf="form.get('nroPasaporte').invalid && (form.get('nroPasaporte').dirty || form.get('nroPasaporte').touched)">
              <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('required')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su pasaporte.</small>
              </span>
              <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('minlength')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un pasaporte válido.</small>
              </span>
              <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('maxlength')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
              </span>
              <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('existe')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El nro. de pasaporte ya se encuentra registrado.</small>
              </span>
            </div>
          </div>

          <div class="p-col-12 p-md-12 p-lg-12 p-xl-11">
            <span class="p-float-label">
              <input pTooltip="Código enviado al correo al momento de postular" type="text" pInputText [maxLength]="30" formControlName="hash">
              <label>Código de acceso</label>
            </span>
            <div *ngIf="form.get('hash').invalid && (form.get('hash').dirty || form.get('hash').touched)">
              <span class="p-error" *ngIf="form.get('hash').hasError('required')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su código de acceso.</small>
              </span>
              <span class="p-error" *ngIf="form.get('hash').hasError('maxlength')">
                <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
              </span>
            </div>
          </div>
        </div>
      </form>
      <div *ngIf="submitted && form.invalid" class="p-col-12">
        <p-message severity="warn" text="Asegúrese de completar los datos."></p-message>
      </div>
      <div *ngIf="response.hasOwnProperty('status')" class="p-col-12" >
        <p-message [severity]="response.status === 'ERROR' ? 'warn' : 'success'" [text]="response.msg"></p-message>
      </div>
      <div class="p-col-12 p-sm-12 p-md-9 p-lg-12 p-xl-12 p-d-flex p-flex-column">
        <div class="p-mr-3 p-mb-3">
          <a routerLink="/recuperar-codigo"><small>Recuperar código de acceso.</small></a>
        </div>
        <div class="p-mr-3 p-mb-3">
          <button 
            pButton 
            type="button" 
            (click)="onSubmit()" 
            icon="pi pi-sign-in" 
            [disabled]="loading" 
            [loading]="loading"
            [label]="loading ? 'Iniciando sesión...' : 'Iniciar sesión'"
            class="btn-primary">
          </button>
        </div>
        <div class="p-mr-3 p-mb-3">
          <button 
            pButton 
            type="button" 
            icon="pi pi-angle-left" 
            label="Volver atrás"
            [routerLink]="[ curso_id ? '/curso-detalle' : '/' ]"
            [queryParams]="{ curso_id: curso_id, version: version, codigoAcceso: codigoAcceso }"
            class="btn-default">
          </button>
        </div>
      </div>
    </p-card>
  </div>

  <div class="p-col-12 p-p-0 p-m-0 wave" style="position: absolute; bottom: 0px;">
    <div class="p-m-0" style="bottom: 0 !important">
      <img src="assets/images/wave-primary.svg">
    </div>
    <div class="p-m-0 wave-bg" style="margin-top: -15px !important;">
    </div>
  </div>
</div>